import { Flex, Grid, GridItem, Text } from '@chakra-ui/react';
import { Input } from '@shared/components';
import { useTranslation } from 'react-i18next';

export const PaymentCreditCardExistent = () => {
  const { t } = useTranslation('cross-seller/payment');

  return (
    <Flex flexDir="column" gap={4}>
      <Text
        color="brand.800"
        fontSize="2xl"
        fontWeight={600}
        textAlign={{ base: 'center', lg: 'start' }}
      >
        {t('cross-seller/payment:cardInfos')}
      </Text>

      <Grid templateColumns="repeat(4, 1fr)" gap={4} w="full">
        <GridItem colSpan={{ base: 2, lg: 1 }}>
          <Input
            label={t('cross-seller/payment:expirationDate')}
            name="expirationDate"
            placeholder={t('cross-seller/payment:expirationDatePlaceholder')}
            type="mask"
            mask="99/99"
          />
        </GridItem>
        <GridItem colSpan={{ base: 2, lg: 1 }}>
          <Input
            label={t('cross-seller/payment:cvv')}
            name="cvv"
            placeholder={t('cross-seller/payment:cvvPlaceholder')}
            type="mask"
            mask="999"
          />
        </GridItem>
      </Grid>
    </Flex>
  );
};
